/**
 * @generated SignedSource<<6fb88f075b5298e66e71f4147ef31159>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AdminSetRestaurantVisibilityInput = {
  isPublic: boolean;
  reason?: string | null;
  restaurantId: string;
};
export type RestaurantsPageVisibilityMutation$variables = {
  input: AdminSetRestaurantVisibilityInput;
};
export type RestaurantsPageVisibilityMutation$data = {
  readonly AdminSetRestaurantVisibility: {
    readonly error: string | null;
    readonly success: boolean;
  };
};
export type RestaurantsPageVisibilityMutation = {
  response: RestaurantsPageVisibilityMutation$data;
  variables: RestaurantsPageVisibilityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminSetRestaurantVisibilityPayload",
    "kind": "LinkedField",
    "name": "AdminSetRestaurantVisibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestaurantsPageVisibilityMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestaurantsPageVisibilityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "92d72837abbe73e1026816bf669ee47f",
    "id": null,
    "metadata": {},
    "name": "RestaurantsPageVisibilityMutation",
    "operationKind": "mutation",
    "text": "mutation RestaurantsPageVisibilityMutation(\n  $input: AdminSetRestaurantVisibilityInput!\n) {\n  AdminSetRestaurantVisibility(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "5510b64b01a33d11ac54c62425197ac0";

export default node;
